import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Icon from '../../icons/Icon';
import buttonThemes from './buttonThemes';

class BaseButton extends Component {
	/*
	getClass = () => {
		let c = this.props.disabled ? 'disabled' : '';
		
		if (this.props.icon !== '') {
			c += this.props.iconRight ? ' icon-right' : 'icon';
		}
		
		if (this.props.toggled) {
			c += ' toggled';
		}
		
		return c;
	};*/
	
	icon = (rightSide) => {
		if (this.props.icon !== '') {
			if ((this.props.iconRight && rightSide)
				|| (!this.props.iconRight && !rightSide)) {
				return (
					<div className="icon-wrap">
						<Icon icon={this.props.icon}
									width="20px"
									height="20px"/>
					</div>
				);
			}
		}
	};
	
	render() {
		return (
			<button>
				{this.props.children}
			</button>
		);
	}
}

BaseButton.propTypes = {
	onClick   : PropTypes.func,
	disabled  : PropTypes.bool,
	theme     : PropTypes.string,
	icon      : PropTypes.string,
	iconRight : PropTypes.bool,
	toggled   : PropTypes.bool,
	type: PropTypes.string,
};

BaseButton.defaultProps = {
	onClick   : null,
	disabled  : false,
	theme     : buttonThemes.ACTION,
	icon      : '',
	iconRight : false,
	toggled   : false,
	type: 'button'
};

export default BaseButton;





// WEBPACK FOOTER //
// ./src/ui/button/BaseButton.js